import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TitleService } from './shared/title.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  private router = inject(Router);
  private titleService = inject(TitleService);

  navHiddenRoutes = [
    '/forget-password',
    '/sign-in',
    '/sign-up',
    '/user/setup',
    '/verify',
    '/user/recover'
  ];

  onActivate() {
    this.titleService.setTitle(null);
  }

  get showNav() {
    const path = this.router.url.split('?')[0];
    return this.navHiddenRoutes.indexOf(path) === -1;
  }
}
